import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import RegionBranchMultipleSelectNew from 'component/branch/RegionBranchMultipleSelectNew'
import ContentHeader from 'component/utils/ContentHeader'
import BodyParameters from 'component/punctualAdjust/bodyParameters'
import SuccessModal from 'component/Modal/SuccessModal'
import NewErrorModal from 'component/Modal/NewErrorModal'
import { renderToastWarn } from 'utils/ToastUtils'
import * as parametersActions from 'action/parameters'
import moment from 'moment'
import _ from 'lodash'
import Field from 'component/utils/Field'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

import './ParametersPerStore.css'

class ParametersPerStore extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    fetchAdjustByStoreRequest: PropTypes.func.isRequired,
    error: PropTypes.object,
    updateAdjustByStore: PropTypes.func.isRequired,
    allParameters: PropTypes.object,
    getParametersError: PropTypes.object,
    reset: PropTypes.func
  }

  state = {
    loadedParameters: false,
    showModal: false,
    modal: '',
    listRegionsAndBranchs: {
      input: {
        checked: false,
        name: "listRegionsAndBranchs",
        value: []
      }
    },
    errorMessage: '',
    fieldsDisabled: true,
  }

  componentDidMount() {
    const { auth: { user }, fetchAdjustByStoreRequest } = this.props

    if (user) {
      this.setState({ loading: true })
      fetchAdjustByStoreRequest(user.dsToken).then(() => {
        if (this.props.getParametersError?.cdStatus === 400) {
          this.handleModal("warningModal")
        }
      })
    }
  }

  handleModal = (modalName) => this.setState({ modal: modalName })

  // Handle form submission
  handleSubmit = async (args) => {
    if (!args) return

    const { auth, updateAdjustByStore } = this.props
    const { listRegionsAndBranchs } = this.state
    
    // Format arguments: convert strings to numbers where needed
    const formattedArgs = Object.keys(args).reduce((acc, key) => {
      let value = args[key]
      if (typeof value === 'string') {
        value = value.replace('.', '').replace(/,/g, '.').replace('%', '')
        acc[key] = parseFloat(value)
      } else {
        acc[key] = value
      }
      return acc
    }, {})

    formattedArgs.dsYear = formattedArgs.dsYear || moment().format('YYYY')
    formattedArgs.cdLdap = auth.user.username
    formattedArgs.dsLdap = auth.user.fullName

    // Validate arguments
    if (!this.validateArgs(formattedArgs)) {
      this.setState({
        errorMessage: this.props.translate('punctual.adjust.parameters.error')
      });
      this.handleModal('warningModal');
      return;
    }
  

    // Prepare branch parameters
    const papBranchs = listRegionsAndBranchs.input.value.map(branch => ({
      idSPAP: null,
      branchRegion: branch.value,
      dsBranchRegion: branch.label,
      inRegion: (!_.isEmpty(branch.idBranches) || !branch.isBranch) ? 1 : 0
    }))

      // Combine formattedArgs with branch parameters and send to API
      const payload = {
        ...formattedArgs,
        papBranchs,
        cdLdap: auth.user.username,
        dsLdap: auth.user.fullName
    };

    console.log("Username (cdLdap):", auth.user.username);
    console.log("Full Name (dsLdap):", auth.user.fullName);
    console.log("Payload being sent:", payload);

    // Update parameters and handle response
    try {
      const resp = await updateAdjustByStore(auth.user.dsToken, payload)
      this.handleResponse(resp)
    } catch (error) {
      renderToastWarn(error.message)
    }
  }

  // Validate the required arguments
  validateArgs = (args) =>  (
      args.qqChanges && args.qqDay &&
      args.adjustStockSystem && args.valueAdjust &&
      args.timoutLatency && args.qqStockLimit && args.valueLimit && args.cdLdap && 
      args.dsLdap 
    )

  handleResponse = (resp) => {

    if (Array.isArray(resp)) {
      // Handle array of errors
      const errorMessage = resp.map(err => err.dsDetail).join('\n')
      this.setState({ errorMessage })
      this.handleModal("warningModal")
    } else if (resp && resp.cdStatus === 200) {
      this.handleModal("successModal")
    } else {
      const errorMessage = typeof resp?.dsDetail === 'string' ? resp.dsDetail : 'Unknown error'
      renderToastWarn(errorMessage)
    }
  }

  successModal = (translate) => (
    <SuccessModal 
      fillButton 
      center 
      handleClose={() => this.handleModal("")}  
      size='sm' 
      buttonText='OK' 
      msg={translate('stock.adjustment.parameters.success')} 
      t={translate} 
    />
  )

  warningModal = (translate) => (
    <NewErrorModal 
      fillButton 
      center 
      handleClose={() => this.handleModal("")} 
      size="sm" 
      msg={this.state.errorMessage || translate('params.supply.notFound')}
      t={translate} 
    />
  )

  renderModal = () => {
    const { modal } = this.state
    const { translate } = this.props
    switch (modal) {
      case 'successModal':
        return this.successModal(translate)
      case 'warningModal':
        return this.warningModal(translate)
      default:
        return null
    }
  }

  handleBranchChange = (values) => {
    const {reset} = this.props;
    const fieldsDisabled = values.length === 0;

    if (values.length === 0 || values.length > 1) {
      this.setState({
        listRegionsAndBranchs: {
          input: {
            checked: false,
            name: "listRegionsAndBranchs",
            value: []
          }
        },
        loadedParameters: false,
        fieldsDisabled
      }, ()=> reset());
    } else if (values.length === 1) {
      const selectedBranch = values[0];

      if( selectedBranch.isBranch) {
      this.fetchBranchDetails(selectedBranch.value, selectedBranch.label);
      } 
    } 
  
    this.setState({
      listRegionsAndBranchs: {
        input: {
          checked: false,
          name: "listRegionsAndBranchs",
          value: values
        }
      },
      fieldsDisabled
    });
    
  } 
  
  fetchBranchDetails = (branchRegion, dsBranchRegion) => {
    const { auth, fetchAdjustByStoreRequest } = this.props;
    
    fetchAdjustByStoreRequest(auth.user.dsToken, branchRegion, dsBranchRegion)
      .then((response) => {
        
        if (response && response.cdStatus === 200) {
          if (response.data) {
            this.setState({ 
              loadedParameters: response.data,
              listRegionsAndBranchs: {
                input: {
                  ...this.state.listRegionsAndBranchs.input,
                  value: response.data.punctualAdjustParamsBranchsModels.map(branch => ({
                    value: branch.branchRegion,
                    label: branch.dsBranchRegion,
                    idBranches: branch.idBranches,
                    isBranch: branch.isBranch
                  }))
                }
              },
            });
          }
        } else {
          console.error("Error fetching data:", response?.dsDetail || "Unknown error");
        }
      })
      .catch((error) => {
        console.error("Failed to fetch branch details:", error);
      });
  }

  render() {
    const { translate, allParameters } = this.props
    const { listRegionsAndBranchs } = this.state

    return (
      <div>
        <ContentHeader>{translate('mobile.ponctual.title.page')}</ContentHeader>
        <Col className="parameters-per-store-container">
          <form className='GamaForm-new'>
            <fieldset>
              <Row>
                <div className='margin-bottom margin-left-small margin-right-small'>
                  <Field {...listRegionsAndBranchs}>
                    <h4 className='no-margin'>
                      <b>{translate('scheduleBlock.branchs')}</b>
                    </h4>
                    <RegionBranchMultipleSelectNew
                      required
                      id='listRegionsAndBranchs'
                      paramsSupply
                      {...listRegionsAndBranchs.input}
                      placeholder={translate('select.one.store')}
                      translate={translate}
                      onChange={(event) => {
                        this.handleBranchChange(event.target.value)
                      }}
                      excludeInactive={true}
                    />
                  </Field>
                </div>
              </Row>
            </fieldset>
          </form>
        </Col>

        <BodyParameters
          translate={translate}
          allParameters={allParameters}
          submit={this.handleSubmit}
          fieldsDisabled={this.state.fieldsDisabled}
        />

        {this.renderModal()}
      </div>
    )
  }
}

const mapStateToProps = ({ parametersReducer }) => ({
  allParameters: parametersReducer.get.record,
  error: parametersReducer.save.error,
  getParametersError: parametersReducer.get.error
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(parametersActions, dispatch)

const ParametersTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(ParametersPerStore)


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParametersTranslated)

export { ParametersPerStore }
